export function pcCycleRegisterSpoiler() {
  const $spoiler = $('.pc-cycle-register-spoiler');
  if (!$spoiler || $spoiler.length === 0) return;

  $spoiler.each((i, el) => {
    const $t = $(el);

    $t.find('.pc-cycle-register-spoiler-toggle').on('click', () => {
      $t.toggleClass('show');
    });
  });
}
